
const digest = '6a5f0d35b3d90c9b4b64cb6c0b1b58456629b7621db6070038d4cdb21d97d6ca';
const classes = {"wrapper":"_wrapper_wn6a1_1","buttonsContainer":"_buttonsContainer_wn6a1_9"};
const css = `._wrapper_wn6a1_1 {
  display: flex;
  padding: 12px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  justify-content: space-between;
}

._buttonsContainer_wn6a1_9 {
  display: flex;
  gap: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  